import type { Dict } from "../types";

export const publicPages: Dict = {
  en: {
    "Unsubscribe.ok.title": "You are unsubscribed",
    "Unsubscribe.ok.body": "You will no longer receive our tips or invitations. Emails about your account keep arriving as usual.",
    "Unsubscribe.invalide.title": "This link is no longer valid",
    "Unsubscribe.invalide.body": "To unsubscribe, just reply to one of our emails.",
    "Unsubscribe.erreur.title": "Something went wrong",
    "Unsubscribe.erreur.body": "Please try again in a few minutes from the link in your email.",
    "Unsubscribe.back": "Back to flowcutai.com",
    "Unsubscribe.salon.ok.body": "You will no longer receive promotional emails from {salon}. Your appointment confirmations and reminders keep arriving as usual.",
    "Unsubscribe.salon.fallback": "your salon",
    "Unsubscribe.salon.invalide.body": "To unsubscribe, reply to one of your salon’s emails.",

    "SubscriptionSuccess.title": "Payment successful!",
    "SubscriptionSuccess.preparing": "Setting up your account, one moment...",
    "SubscriptionSuccess.subtitle": "Your Flowcut subscription is now active.",
    "SubscriptionSuccess.checkEmailTitle": "Check your inbox",
    "SubscriptionSuccess.checkEmailBody": "We sent you an email with the link to create your account. It is valid for 7 days.",
    "SubscriptionSuccess.backHome": "Back to home",
    "SubscriptionSuccess.noEmail": "Didn't get the email? Check your spam folder or write to julien@flowcutai.com.",

    // NativeHome
    "NativeHome.signIn": "Sign in",
    "NativeHome.bookDemo": "Book your demo",
    "NativeHome.privacyPolicy": "Privacy policy",
    "NativeHome.switchLanguage": "Change language",
    "PaymentLink.loading": "Loading your payment…",
    "PaymentLink.payTo": "Payment to",
    "PaymentLink.yourSalon": "your salon",
    "PaymentLink.invoice": "Invoice",
    "PaymentLink.amountDue": "Amount due",
    "PaymentLink.payNow": "Pay now",
    "PaymentLink.redirecting": "Redirecting…",
    "PaymentLink.securedByStripe": "Secure payment processed by Stripe",
    "PaymentLink.paidConfirmedTitle": "Thank you, your payment is confirmed",
    "PaymentLink.paidConfirmedBody": "Nothing is left to pay on this invoice. You can close this page.",
    "PaymentLink.paidPendingTitle": "We have received your payment",
    "PaymentLink.paidPendingBody": "Confirmation is arriving in a moment. There is no need to pay again.",
    "PaymentLink.alreadyPaidTitle": "This invoice has been settled",
    "PaymentLink.alreadyPaidBody": "Nothing is left to pay. If you think this is a mistake, contact the salon.",
    "PaymentLink.cancelledTitle": "This invoice was cancelled",
    "PaymentLink.cancelledBody": "The salon cancelled this invoice. Contact them if you have a question.",
    "PaymentLink.expiredTitle": "This link is no longer valid",
    "PaymentLink.expiredBody": "Payment links expire after a few days. Ask the salon to send you a new one.",
    "PaymentLink.errorTitle": "Something went wrong",
    "PaymentLink.errorBody": "We could not load this payment. Your invoice has not been charged.",
    "PaymentLink.retry": "Try again",
  },
  fr: {
    "Unsubscribe.ok.title": "Vous êtes désabonné",
    "Unsubscribe.ok.body": "Vous ne recevrez plus nos conseils ni nos invitations. Les courriels liés à votre compte continuent d’arriver normalement.",
    "Unsubscribe.invalide.title": "Ce lien n’est plus valide",
    "Unsubscribe.invalide.body": "Pour vous désabonner, répondez simplement à l’un de nos courriels.",
    "Unsubscribe.erreur.title": "Un problème est survenu",
    "Unsubscribe.erreur.body": "Réessayez dans quelques minutes à partir du lien de votre courriel.",
    "Unsubscribe.back": "Retour à flowcutai.com",
    "Unsubscribe.salon.ok.body": "Vous ne recevrez plus les courriels promotionnels de {salon}. Vos confirmations et rappels de rendez-vous continuent d’arriver normalement.",
    "Unsubscribe.salon.fallback": "votre salon",
    "Unsubscribe.salon.invalide.body": "Pour vous désabonner, répondez à l’un des courriels de votre salon.",

    "SubscriptionSuccess.title": "Paiement réussi !",
    "SubscriptionSuccess.preparing": "Préparation de votre compte, un instant...",
    "SubscriptionSuccess.subtitle": "Votre abonnement Flowcut a été activé avec succès.",
    "SubscriptionSuccess.checkEmailTitle": "Vérifiez votre boîte courriel",
    "SubscriptionSuccess.checkEmailBody": "Nous vous avons envoyé un courriel contenant le lien pour créer votre compte. Il est valide pendant 7 jours.",
    "SubscriptionSuccess.backHome": "Retour à l'accueil",
    "SubscriptionSuccess.noEmail": "Vous n'avez pas reçu le courriel ? Vérifiez vos indésirables ou écrivez-nous à julien@flowcutai.com.",

    // NativeHome
    "NativeHome.signIn": "Se connecter",
    "NativeHome.bookDemo": "Planifiez votre démo",
    "NativeHome.privacyPolicy": "Politiques de confidentialité",
    "NativeHome.switchLanguage": "Changer de langue",
    "PaymentLink.loading": "Chargement de votre paiement…",
    "PaymentLink.payTo": "Paiement à",
    "PaymentLink.yourSalon": "votre salon",
    "PaymentLink.invoice": "Facture",
    "PaymentLink.amountDue": "Montant dû",
    "PaymentLink.payNow": "Payer maintenant",
    "PaymentLink.redirecting": "Redirection…",
    "PaymentLink.securedByStripe": "Paiement sécurisé traité par Stripe",
    "PaymentLink.paidConfirmedTitle": "Merci, votre paiement est confirmé",
    "PaymentLink.paidConfirmedBody": "Il ne reste rien à payer sur cette facture. Vous pouvez fermer cette page.",
    "PaymentLink.paidPendingTitle": "Nous avons reçu votre paiement",
    "PaymentLink.paidPendingBody": "La confirmation arrive dans un instant. Inutile de payer de nouveau.",
    "PaymentLink.alreadyPaidTitle": "Cette facture a été réglée",
    "PaymentLink.alreadyPaidBody": "Il ne reste rien à payer. Si vous croyez qu'il s'agit d'une erreur, communiquez avec le salon.",
    "PaymentLink.cancelledTitle": "Cette facture a été annulée",
    "PaymentLink.cancelledBody": "Le salon a annulé cette facture. Communiquez avec lui si vous avez une question.",
    "PaymentLink.expiredTitle": "Ce lien n'est plus valide",
    "PaymentLink.expiredBody": "Les liens de paiement expirent après quelques jours. Demandez au salon de vous en envoyer un nouveau.",
    "PaymentLink.errorTitle": "Une erreur est survenue",
    "PaymentLink.errorBody": "Nous n'avons pas pu charger ce paiement. Votre facture n'a pas été débitée.",
    "PaymentLink.retry": "Réessayer",
  },
};
